﻿import SlimSelect from 'slim-select';

document.addEventListener('DOMContentLoaded', function (event) {
  initSlimSelects();
});

let inDebounce;
const slimSelects = [];

const defaultSettings = {
  placeholderText: 'Seleziona',
  searchText: 'Nessun risultato trovato',
  searchingText: 'Ricerca in corso...',
  searchPlaceholder: 'Cerca...',
};

export function initSlimSelects() {
  slimSelects.forEach(element => element.destroy());

  const commonSelects = document.querySelectorAll('[data-slimselect]');
  commonSelects.forEach((element, index, parent) => {
	let settings = JSON.parse(element.attributes['data-slimselect'].value);
	settings = {
	  ...defaultSettings,
	  ...settings,
	  }
	let data = settings.data;
	try {
	  let ss = new SlimSelect({
		select: element,
		settings: settings,
		data: data
	  });

	  slimSelects.push(ss);
	} catch { }
  })
}

//export function initSlimSelect() {
//  slimSelects.forEach((element) => {
//	element.destroy();
//  });
//  const commonSelects = document.querySelectorAll('[data-slimselect]');
//  commonSelects.forEach((element, index, parent) => {
//	let options = JSON.parse(element.attributes['data-slimselect'].value)

//	if (options.tags) {
//	  options = {
//		addable: function (value) { return value; },
//		...options
//	  }
//	}

//	if (options.ajaxUrl) {
//	  let url = options.ajaxUrl;
//	  let propertyNames = [];
//	  let parameterNames = [];

//	  if (options.ajaxProperties) {
//		propertyNames = options.ajaxProperties.concat(propertyNames);
//	  } else {
//		propertyNames.push('name');
//	  }

//	  if (options.ajaxParameters) {
//		parameterNames = options.ajaxParameters.concat(parameterNames);
//	  }

//	  options = {
//		ajax: function (search, callback) {
//		  clearTimeout(inDebounce);

//		  inDebounce = setTimeout(function () {
//			if (search.length < 3) {
//			  callback('Inserisci almeno 3 caratteri');
//			  return;
//			}
//			let data = new URLSearchParams();
//			data.append('term', search);
//			propertyNames.forEach((propertyName, index) => {
//			  data.append('searchableProperties', propertyName);
//			});

//			parameterNames.forEach((parameter, index) => {
//			  let parameterName = parameter.substring(parameter.lastIndexOf('.') + 1);
//			  let value = document.querySelector(`[name='${parameter}']`).value;
//			  if (value !== '') {
//				data.append(parameterName, value);
//			  }
//			});
//			if (options.ajaxType) {
//			  data.append('type', options.ajaxType);
//			}

//			fetch(`${url}?${data.toString()}`, {
//			  method: 'GET',
//			  headers: { 'Content-Type': 'application/json' },
//			})
//			  .then(response => response.json())
//			  .then(data => {
//				let result = data.map(element => {
//				  let text = '';
//				  propertyNames.forEach((name, index) => {
//					text += `${element[name]} `;
//				  });
//				  return {
//					value: element.id,
//					text: text.trim()
//				  }
//				});
//				callback(result);
//			  })
//			  .catch((errors) => { console.error(errors); callback(false); });
//		  }, 1000);


//		},
//		...options
//	  }
//	}

//	let ss = new SlimSelect({
//	  select: element,
//	  ...options,
//	  ...defaultOptions,
//	  onChange: function (info) {
//		if (ss.selected()) {
//		  ss.slim.container.classList.add('hasValue');
//		} else {
//		  ss.slim.container.classList.remove('hasValue');
//		}
//	  }
//	});

//	if (ss.selected()) {
//	  ss.slim.container.classList.add('hasValue');
//	}

//	slimSelects.push(ss);
//  })
//}

